/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { collectionSchema } from '../collection-schema';

const collectionTreeNodeSchema: z.ZodType<ICollectionTreeNode> = collectionSchema.extend({
  children: z.lazy(() => z.array(collectionTreeNodeSchema)),
});

export type ICollectionTreeNode = z.infer<typeof collectionSchema> & {
  children: ICollectionTreeNode[];
};

const listUserCollectionsDataSchema = z.array(collectionTreeNodeSchema);

export type IListUserCollectionsResponseData = ICollectionTreeNode[];

export const listUserCollectionsResponseSchema = createApiResponseSchema(
  listUserCollectionsDataSchema,
) as z.ZodSchema<IAPI<IListUserCollectionsResponseData>>;

export type IListUserCollectionsResponse = IAPI<IListUserCollectionsResponseData>;
